import React, { Component } from 'react';
import { connect } from 'react-redux';

import { roles } from '../../constants';
import { alertActions } from '../../modules/alert';
import { utilHelper } from '../../helpers';
import BottomButton from './BottomButton';
import { BeginEndDateInput, ElvNoInput, FloorEndInput, FloorStartInput, OpbNameInput, OpbNoInput, OpbTypeSelect, SiteNameInput, SiteNumInput, SlotCodeSelect } from '../Common/InputBox';

class OpbMod extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            opbInfo: {
                ...props.opbInfo,
                floorStart: props.opbInfo.floorStart - 10,
                floorEnd: props.opbInfo.floorEnd - 9,
            },
            opbInfoStatus: false,
            submitted: false,
            boardCodes: utilHelper.getCodesByGroup('OT'),
            typeCodes: utilHelper.getCodesByParent(props.opbInfo.boardCode),
            slotCodes: utilHelper.getCodesByGroup('OP')
        }
    }

    componentDidMount = () => {
        const floorStartType = this.state.opbInfo.floorStart > -1 ? "지상" : "지하";
        const contractYN = this.state.opbInfo.opbStatus === "ST001" ? "Y" : "N";

        this.setState({
            opbInfo: {
                ...this.state.opbInfo,
                floorStartType: floorStartType,
                contractYN: contractYN
            }
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.opbInfo !== this.props.opbInfo) {
            const floorStartType = this.props.opbInfo.floorStart > 9 ? "지상" : "지하";
            const contractYN = this.props.opbInfo.opbStatus === "ST001" ? "Y" : "N";

            this.setState({
                open: false,
                opbInfo: {
                    ...this.props.opbInfo,
                    floorStart: this.props.opbInfo.floorStart - 10,
                    floorEnd: this.props.opbInfo.floorEnd - 9,
                    floorStartType: floorStartType,
                    contractYN: contractYN
                }
            });
        }
    }

    handleValueChange = (e) => {
        if (e.target.name === "boardCode") {
            this.setState({
                opbInfo: {
                    ...this.state.opbInfo,
                    boardCode: e.target.value,
                    typeCode: "",
                },
                opbInfoStatus: true,
                typeCodes: utilHelper.getCodesByParent(e.target.value),
            });
        }
        else if (e.target.name === "floorStart") {
            const isNumber = utilHelper.isNumber(e.target.value);
            this.setState({
                opbInfo: {
                    ...this.state.opbInfo,
                    floorStart: isNumber ? Math.abs(e.target.value) : this.state.opbInfo.floorStart
                },
                opbInfoStatus: true,
            });
        }
        else if (e.target.name === "floorEnd") {
            const isNumber = utilHelper.isNumber(e.target.value);
            this.setState({
                opbInfo: {
                    ...this.state.opbInfo,
                    floorEnd: isNumber ? Math.abs(e.target.value) : this.state.opbInfo.floorEnd
                },
                opbInfoStatus: true,
            })
        }
        else {
            this.setState({
                opbInfo: {
                    ...this.state.opbInfo,
                    [e.target.name]: e.target.value,
                },
                opbInfoStatus: true,
            });
        }
        this.props.setOpbInfoStatus(); // opbInfo가 수정되었음을 PropertiesDialog에 알림
    };

    setSubmitted = () => {
        this.setState({
            submitted: true,
        });
    };

    handleErrors = (error) => {
        console.log(error.toString());
        if (error.response === undefined)
            this.props.errorAlerts("알 수 없는 오류가 발생하였습니다. 관리자에게 문의하시기 바랍니다.", "/home");
        else {
            if (error.response.status === 401)
                this.props.errorAlerts("권한이 없습니다.", "/login");
            else
                this.props.errorAlerts(error.response.data.message);
        }
    };

    render() {
        const { myInfo } = this.props;
        const isUserRole = myInfo.myRole === roles.userRole;
        const { opbInfo, submitted, boardCodes, typeCodes, slotCodes, opbInfoStatus } = this.state;
        const { siteName, siteNum, opbNo, elvNo, opbName, coBeginDate, coEndDate, boardCode, typeCode, floorStartType, floorStart, floorEnd, patchStandard, slotCode, contractYN } = opbInfo;

        return (
            <>
                <div className="s-cont-wrap">
                    <div className="s-flex-auto">
                        <div className="s-form-cont">

                            <div className="row">
                                <div className="contents-mod-title col-lg-2 col-md-2 col-sm-3 col-4">현장명</div>
                                <div className="text-align-left col-lg-10 col-md-10 col-sm-9 col-8">
                                    <SiteNameInput siteName={siteName} disabled />
                                </div>
                            </div>

                            <div className="row">
                                <div className="contents-mod-title col-lg-2 col-md-2 col-sm-3 col-4">PrjNo</div>
                                <div className="text-align-left col-lg-10 col-md-10 col-sm-9 col-8">
                                    <SiteNumInput siteNum={siteNum} disabled />
                                </div>
                            </div>

                            <div className="row">
                                <div className="contents-mod-title col-lg-2 col-md-2 col-sm-3 col-4">호기번호</div>
                                <div className="text-align-left col-lg-10 col-md-10 col-sm-9 col-8">
                                    <OpbNoInput opbNo={opbNo} disabled />
                                </div>
                            </div>

                            <div className="row">
                                <div className="contents-mod-title col-lg-2 col-md-2 col-sm-3 col-4">승강기 번호</div>
                                <div className={`text-align-left col-lg-10 col-md-10 col-sm-9 col-8 ${submitted && !elvNo ? 'has-error' : ''}`}>
                                    <ElvNoInput elvNo={elvNo} handleValueChange={this.handleValueChange} disabled={isUserRole} />
                                </div>
                            </div>

                            <div className="row">
                                <div className="contents-mod-title col-lg-2 col-md-2 col-sm-3 col-4">호기이름<span className="text-color-red">*</span></div>
                                <div className={`text-align-left col-lg-10 col-md-10 col-sm-9 col-8 ${submitted && !opbName ? 'has-error' : ''}`}>
                                    <OpbNameInput opbName={opbName} handleValueChange={this.handleValueChange} disabled={isUserRole} />
                                    {submitted && !opbName &&
                                        <div className="help-block">* 호기 이름은 필수 입력 값입니다.</div>
                                    }
                                </div>
                            </div>

                            <div className="row">
                                <div className="contents-mod-title col-lg-2 col-md-2 col-sm-3 col-4">계약기간</div>
                                <div className="text-align-left col-lg-10 col-md-10 col-sm-9 col-8">
                                    <BeginEndDateInput beginDate={utilHelper.getStringDate(new Date(coBeginDate))} endDate={utilHelper.getStringDate(new Date(coEndDate))} disabled />
                                </div>
                            </div>

                            <div className="row">
                                <div className="contents-mod-title col-lg-2 col-md-2 col-sm-3 col-4">타입<span className="text-color-red">*</span></div>
                                <div className={`text-align-left col-lg-10 col-md-10 col-sm-9 col-8 ${submitted && (!boardCode || !typeCode) ? ' has-error' : ''}`}>
                                    <OpbTypeSelect boardCodes={boardCodes} typeCodes={typeCodes} boardCode={boardCode} typeCode={typeCode} handleValueChange={this.handleValueChange} disabled={isUserRole} />
                                    {(submitted && (!boardCode || !typeCode)) &&
                                        <div className="help-block">* 타입은 필수 입력 값입니다.</div>
                                    }
                                </div>
                            </div>

                            <div className="row">
                                <div className="contents-mod-title col-lg-2 col-md-2 col-sm-3 col-4">최저층설정<span className="text-color-red">*</span></div>
                                <div className={`text-align-left col-lg-10 col-md-10 col-sm-9 col-8 ${submitted && (!floorStartType || (floorStartType === "지하" && parseInt(floorStart) === 0)) ? ' has-error' : ''}`}>
                                    <FloorStartInput floorStartType={floorStartType} floorStart={floorStart} handleValueChange={this.handleValueChange} typeDisabled={isUserRole} disabled={isUserRole || floorStartType !== '지하'} />
                                    {(submitted && (!floorStartType || (floorStartType === "지하" && parseInt(floorStart) === 0))) &&
                                        <div className="help-block">* 최저층 정보는 필수 입력 값입니다.</div>
                                    }
                                </div>
                            </div>

                            <div className="row">
                                <div className="contents-mod-title col-lg-2 col-md-2 col-sm-3 col-4">최고층설정<span className="text-color-red">*</span></div>
                                <div className={`text-align-left col-lg-10 col-md-10 col-sm-9 col-8 ${submitted && !floorEnd ? ' has-error' : ''}`}>
                                    <FloorEndInput floorEnd={floorEnd} handleValueChange={this.handleValueChange} disabled={isUserRole} />
                                    {submitted && !floorEnd &&
                                        <div className="help-block">* 최고층 정보는 필수 입력 값입니다.</div>
                                    }
                                </div>
                            </div>

                            <div className="row">
                                <div className="contents-mod-title col-lg-2 col-md-2 col-sm-3 col-4">패치설정<span className="text-color-red">*</span></div>
                                <div className="text-align-left col-lg-10 col-md-10 col-sm-9 col-8">
                                    <div className="s-rdo-box" onChange={this.handleValueChange}>
                                        <label>
                                            <input
                                                type="radio"
                                                name="patchStandard"
                                                value="Y"
                                                checked={patchStandard === "Y"}
                                                readOnly
                                                disabled={isUserRole}
                                            />
                                            표준
                                        </label>
                                        <label className="s-ml-10">
                                            <input
                                                type="radio"
                                                name="patchStandard"
                                                value="N"
                                                checked={patchStandard === "N"}
                                                readOnly
                                                disabled={isUserRole}
                                            />
                                            비표준
                                        </label>
                                        {submitted && !patchStandard &&
                                            <div className="help-block">* 패치설정은 필수 입력 값입니다.</div>
                                        }
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="contents-mod-title col-lg-2 col-md-2 col-sm-3 col-4">Display위치<span className="text-color-red">*</span></div>
                                <div className={`text-align-left col-lg-10 col-md-10 col-sm-9 col-8 ${submitted && !slotCode ? 'has-error' : ''}`}>
                                    <SlotCodeSelect slotCodes={slotCodes} slotCode={slotCode} handleValueChange={this.handleValueChange} disabled={isUserRole} />
                                    {submitted && !slotCode &&
                                        <div className="help-block">* Display위치는 필수 입력 값입니다.</div>
                                    }
                                </div>
                            </div>

                            <div className="row">
                                <div className="contents-mod-title col-lg-2 col-md-2 col-sm-3 col-4">계약설정<span className="text-color-red">*</span></div>
                                <div className="text-align-left col-lg-10 col-md-10 col-sm-9 col-8">
                                    <div className="s-rdo-box" onChange={this.handleValueChange}>
                                        <label>
                                            <input
                                                type="radio"
                                                name="contractYN"
                                                value="Y"
                                                checked={contractYN === "Y"}
                                                readOnly
                                                disabled={isUserRole}
                                            />
                                            계약진행
                                        </label>
                                        <label className="s-ml-10">
                                            <input
                                                type="radio"
                                                name="contractYN"
                                                value="N"
                                                checked={contractYN === "N"}
                                                readOnly
                                                disabled={isUserRole}
                                            />
                                            계약중단
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <BottomButton opbInfo={opbInfo} mode="mod" opbInfoStatus={opbInfoStatus} setSubmitted={this.setSubmitted} stateRefresh={this.props.stateRefresh} />
            </>
        )
    }
}

function mapState(state) {
    const { userinfo } = state;
    const myInfo = userinfo.item;
    return { myInfo };
}

const actionCreators = {
    errorAlerts: alertActions.error,
    successAlerts: alertActions.success
};

export default connect(mapState, actionCreators)(OpbMod);